import { render, staticRenderFns } from "./TextEditorButton.vue?vue&type=template&id=7bc4e892&"
import script from "./TextEditorButton.vue?vue&type=script&lang=js&"
export * from "./TextEditorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports